import React from "react";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@material-ui/core/Button";

export type SimpleDialogState = {
  open: boolean,
  title: string,
  description: string,
  onOk: () => void,
}

export const defaultDialogState: SimpleDialogState = {
  open: false,
  title: "",
  description: "",
  onOk: () => {}
}

const SimpleDialog = (props: SimpleDialogState & {
  onClose: () => void,
}) => {
  return <Dialog open={props.open}
                      onClose={props.onClose}
                      aria-labelledby="order-delete-alert-dialog"
                      aria-describedby="check-order-delete-alert">
    <DialogTitle id={"order-delete-alert-title"}>
      {props.title}
    </DialogTitle>
    {props.description.length !== 0 &&
        <DialogContent>
            <DialogContentText id="delete-dialog-description">
              {props.description}
            </DialogContentText>
        </DialogContent>
    }
    <DialogActions>
      <Button onClick={props.onClose} color={"primary"}>キャンセル</Button>
      <Button onClick={() => {
        props.onOk();
        props.onClose();
      }} autoFocus color={"primary"}>
        OK
      </Button>
    </DialogActions>
  </Dialog>
}

export default SimpleDialog;